"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAVIGATION_ARROWS_BEHAVIOR = void 0;
var NAVIGATION_ARROWS_BEHAVIOR;
(function (NAVIGATION_ARROWS_BEHAVIOR) {
    NAVIGATION_ARROWS_BEHAVIOR[NAVIGATION_ARROWS_BEHAVIOR["ON_HOVER"] = 0] = "ON_HOVER";
    NAVIGATION_ARROWS_BEHAVIOR[NAVIGATION_ARROWS_BEHAVIOR["ALWAYS"] = 1] = "ALWAYS";
})(NAVIGATION_ARROWS_BEHAVIOR = exports.NAVIGATION_ARROWS_BEHAVIOR || (exports.NAVIGATION_ARROWS_BEHAVIOR = {}));
//# sourceMappingURL=navigation-arrows-behavior.js.map